import http from './httpService';
/*global API */
const stripeEndpoint = `${API}/api/Stripe`;

export function getCustomer() {
  return http.get(stripeEndpoint);
}
